<div
  class="checkin__spinner__wrapper"
  [ngStyle]="{
    height : wrapperSize,
    width : wrapperSize
  }">
  <div class="checkin__spinner__item" [ngStyle]="{
    'border-left': '1px solid ' + loaderAlphaColor + '',
    'border-top': '1px solid ' + loaderAlphaColor + '',
    height : loaderSize,
    width : loaderSize
  }"></div>
  <div
    class="checkin__spinner__item checkin__spinner__item--active"
    [ngStyle]="{
      'border-bottom': '1px solid ' + corporativeColor + '',
      'border-right': '1px solid ' + corporativeColor + '',
      height : loaderSize,
      width : loaderSize
    }">
  </div>
</div>
